import React from 'react';
import { useCountUp } from '../hooks/useCountUp';
import { stats } from '../data/site';
const HERO_IMAGE = 'https://cdn.magicpatterns.com/uploads/gzi9SBtBVPokictz7gLeCR/img3.jpg';
function Stat({
  value,
  suffix,
  label
}: {
  value: number;
  suffix: string;
  label: string;
}) {
  const {
    ref,
    value: current
  } = useCountUp(value);
  return <div className="border-l border-white/20 pl-4 first:border-l-0 first:pl-0 sm:pl-6" data-id="element-175" data-mp="4na0yr7f9w7e">
      <p className="font-display text-3xl text-gold-400 md:text-[40px]" data-id="element-176" data-mp="12861e06dces4">
        <span ref={ref} data-id="element-177" data-mp="x9un9d91ji43">{current.toLocaleString('en-US')}</span>
        {suffix}
      </p>
      <p className="mt-1 text-[11px] uppercase tracking-[0.14em] text-white/70 md:text-xs" data-id="element-178" data-mp="sarvuvlzhael">
        {label}
      </p>
    </div>;
}
export function Hero() {
  return <section id="inicio" className="relative isolate flex min-h-[100svh] items-center" data-id="element-179" data-mp="nekn6v27dksy">
      {/* Fondo: imagen aérea del proyecto (reemplazable por un video en loop) */}
      <img src={HERO_IMAGE} alt="Vista aérea de Hacienda El Rodeo y su acceso sobre carretera asfaltada, Santa Catarina Mita, Jutiapa" className="absolute inset-0 -z-10 h-full w-full object-cover" data-id="element-180" data-mp="380vz9yqbyvdo" />
      <div className="absolute inset-0 -z-10 bg-forest-900/72" aria-hidden="true" data-id="element-181" data-mp="3o59bpicfn4e0" />

      <div className="mx-auto w-full max-w-7xl px-5 pb-16 pt-32 lg:px-8" data-id="element-182" data-mp="39cflb1vmh3uk">
        <div className="max-w-3xl" data-id="element-183" data-mp="3e84m18jdoqsg">
          <p className="flex items-center gap-2.5 text-[11px] font-semibold uppercase tracking-[0.2em] text-gold-400" data-id="element-184" data-mp="3eb91x367hayy">
            <span className="relative grid h-2 w-2 place-items-center" data-id="element-185" data-mp="358hncui19z33">
              <span className="absolute inset-0 animate-ping rounded-full bg-gold-400/70" data-id="element-186" data-mp="35au9ljutqvly" />
              <span className="h-2 w-2 rounded-full bg-gold-400" data-id="element-187" data-mp="2qhqudj4pgtye" />
            </span>
            Solo quedan 12 lotes disponibles
          </p>

          <h1 className="mt-5 font-display text-[44px] leading-[1.03] text-white sm:text-6xl lg:text-[72px]" data-id="element-188" data-mp="2hincgih9yklh">
            Tu tierra, tu futuro
          </h1>

          <p className="mt-6 max-w-xl text-base leading-relaxed text-white/85 md:text-lg" data-id="element-189" data-mp="2lmuyg7wclmg0">
            Invierte en lo que nunca pierde valor. Lotes desde{' '}
            <strong className="font-semibold text-white" data-id="element-190" data-mp="na9xyj16r4ia">Q35,000</strong> con financiamiento directo,
            sin banco y con escrituración incluida.
          </p>

          <div className="mt-9 flex flex-col gap-3 sm:flex-row" data-id="element-191" data-mp="ddf4iejrruav">
            <a href="#lotes" className="rounded-full bg-gold px-8 py-4 text-center text-[12px] font-semibold uppercase tracking-[0.14em] text-white transition-[background-color,transform] duration-150 ease-smooth hover:bg-gold-600 active:scale-[0.98]" data-id="element-192" data-mp="db2d7as4g7l5">
              Ver lotes disponibles
            </a>
            <a href="#simulador" className="rounded-full border border-white/40 px-8 py-4 text-center text-[12px] font-semibold uppercase tracking-[0.14em] text-white transition-[background-color,border-color] duration-150 ease-smooth hover:border-white hover:bg-white/10" data-id="element-193" data-mp="x1w8ed5p8zjz">
              Calcular mi cuota
            </a>
          </div>

          <dl className="mt-14 grid grid-cols-2 gap-y-8 sm:grid-cols-4 sm:gap-y-0" data-id="element-194" data-mp="21amwtbz2vwne">
            {stats.map(stat => <Stat key={stat.label} value={stat.value} suffix={stat.suffix} label={stat.label} data-id="element-195" data-mp="269r3nvyj5iak" />)}
          </dl>
        </div>
      </div>
    </section>;
}